import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "..";
import { State } from "../state";

export const userSlice = createSlice({
    name: "user",
    initialState: {
        isSwitchUserDialogOpen: false,
        selectedSwitchSeatType: null,
    } as State.User,

    reducers: {
        setIsSwitchUserDialogOpen: (state, action: PayloadAction<boolean>) => {
            state.isSwitchUserDialogOpen = action.payload;
        },

        setSelectedSwitchSeatType: (state, action: PayloadAction<"S" | "M" | "L" | null>) => {
            state.selectedSwitchSeatType = action.payload;
        },
    },
});

export const { setIsSwitchUserDialogOpen, setSelectedSwitchSeatType } = userSlice.actions;

export const useUserSlice = () => useSelector((state: RootState) => state.user);

export default userSlice.reducer;
